// Content saved by the old CKEditor 5 uses markup the new editor doesn't parse
// on its own. Convert it so existing advices and legal changes open unchanged.
//
// CKEditor to-do list:
//   <ul class="todo-list"><li><label class="todo-list__label">
//     <input type="checkbox" disabled checked><span class="todo-list__label__description">Text</span>
//   </label>...</li></ul>
// Tiptap task list:
//   <ul data-type="taskList"><li data-type="taskItem" data-checked="true"><p>Text</p>...</li></ul>
export const normalizeLegacyHtml = (html) => {
  if (!html) {
    return ''
  }
  if (html.indexOf('todo-list') === -1) {
    return html
  }
  const doc = new DOMParser().parseFromString(html, 'text/html')
  doc.querySelectorAll('ul.todo-list').forEach(list => {
    list.classList.remove('todo-list')
    list.setAttribute('data-type', 'taskList')
    Array.from(list.children).forEach(item => {
      if (item.tagName !== 'LI') {
        return
      }
      const label = item.querySelector(':scope > label')
      const checkbox = label && label.querySelector('input[type="checkbox"]')
      const description = label && label.querySelector('.todo-list__label__description')
      item.setAttribute('data-type', 'taskItem')
      item.setAttribute('data-checked', checkbox && checkbox.hasAttribute('checked') ? 'true' : 'false')
      if (label) {
        const paragraph = doc.createElement('p')
        paragraph.innerHTML = description ? description.innerHTML : label.textContent
        label.replaceWith(paragraph)
      }
    })
  })
  return doc.body.innerHTML
}
